/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type StepScheduleDelayDelayType = typeof StepScheduleDelayDelayType[keyof typeof StepScheduleDelayDelayType];


export const StepScheduleDelayDelayType = {
  weekdays: 'weekdays',
  business_days: 'business_days',
  weeks: 'weeks',
  months: 'months',
} as const;
